"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CameraPreview = void 0;
const React = require("react");
const styles = require("./styles.scss");
const globalCameraStyles = require("../../styles.scss");
const cssComposer_1 = require("../../../../../../helpers/cssComposer");
const ImgBlock_1 = require("../../../ImgBlock");
const css = (0, cssComposer_1.default)(styles);
const globalStyles = (0, cssComposer_1.default)(globalCameraStyles);
const CameraPreview = ({ image, round = false }) => {
    const classNames = {
        wrapper: true,
        round
    };
    const src = image instanceof Blob ? URL.createObjectURL(image) : image;
    return (React.createElement("div", { className: globalStyles(classNames), "data-test": "preview", "data-test-is-round": round },
        React.createElement(ImgBlock_1.ImgBlock, { src: src, className: css("cameraPreview") })));
};
exports.CameraPreview = CameraPreview;
//# sourceMappingURL=index.js.map